import type { HookFormSubmitHandler } from 'common/models';
import { Button } from 'components';
import { FormError, FormWrapper, PasswordInput } from 'components/forms/hook-form';
import { useCustomTranslation } from 'helpers/translationHelper';
import { useValidators } from 'helpers/validation';
import React from 'react';
import { useFormContext } from 'react-hook-form';

interface Props {
  onSubmit: HookFormSubmitHandler<PasswordFormValues>;
}

export interface PasswordFormValues {
  newPassword: string;
  newPasswordAgain: string;
}

const PasswordFormFields = () => {
  const { t } = useCustomTranslation();
  const validators = useValidators();
  const { getValues } = useFormContext<PasswordFormValues>();

  return (
    <>
      <PasswordInput
        label={t('password.forms.newPasswordLabel')}
        name="newPassword"
        required
        options={{ required: validators.required }}
      />
      <PasswordInput
        label={t('password.forms.newPasswordAgainLabel')}
        name="newPasswordAgain"
        required
        options={{
          required: validators.required,
          validate: (value) => validators.samePasswordCheck(value, getValues('newPassword'))
        }}
      />
    </>
  );
};

const PasswordFormSubmitButton = () => {
  const {
    formState: { isSubmitting }
  } = useFormContext<PasswordFormValues>();
  const { t } = useCustomTranslation();

  return (
    <Button loading={isSubmitting} htmlType="submit" type="primary" className="public-btn">
      {t('password.forms.createPasswordButton')}
    </Button>
  );
};

const PasswordForm: React.FC<Props> = (props): React.ReactElement => {
  const { onSubmit } = props;

  const defaultValues: PasswordFormValues = {
    newPassword: '',
    newPasswordAgain: ''
  };

  return (
    <FormWrapper<PasswordFormValues> defaultValues={defaultValues} onSubmit={onSubmit}>
      <PasswordFormFields />
      <FormError />
      <PasswordFormSubmitButton />
    </FormWrapper>
  );
};

export default PasswordForm;
